import { useQuery } from 'react-query';

import { getObjectEncs } from 'api/encounters/getObjectEnc';

export const useGetObjectEncs = (slug: string, enabled: boolean = true) => {
  const { data, refetch, isLoading, isFetching } = useQuery('objectEncs', () => getObjectEncs(slug), {
    enabled,
    refetchOnWindowFocus: false,
  });

  return { data, refetch, isLoading, isFetching };
};

export default useGetObjectEncs;
